import type { AutoDecryptField } from './use-auto-decrypt-controls';

export const AUTO_DECRYPT_DURATION = 8 * 60 * 60 * 1000; // 8 hours

export const allFields: AutoDecryptField[] = [
  'id.first_name',
  'id.middle_name',
  'id.last_name',
  'id.dob',
  'id.ssn4',
  'id.ssn9',
  'id.address_line1',
  'id.address_line2',
  'id.city',
  'id.state',
  'id.zip',
  'id.country',
  'id.email',
  'id.phone_number',
  'id.us_legal_status',
  'id.visa_kind',
  'id.visa_expiration_date',
  'id.nationality',
  'id.citizenships',
  'business.name',
  'business.dba',
  'business.website',
  'business.phone_number',
  'business.tin',
  'business.address_line1',
  'business.address_line2',
  'business.city',
  'business.state',
  'business.zip',
  'business.country',
  'business.corporation_type',
  'business.formation_state',
  'business.formation_date',
  'investor_profile',
  'custom',
  'document',
  'card',
  'bank',
];

export const sensitiveFieldPrefixes: AutoDecryptField[] = [
  'id.ssn4',
  'id.ssn9',
  'card',
  'bank',
  'id.itin',
  'id.us_tax_id',
];
